import { Group, List, Paper, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

export default function PermissionGuide() {
  return (
    <Paper bg="gray.0" p="md">
      <Group gap={6} align="center" mb="xs">
        <IconAlertCircle size={16} />
        <Text fw={500} size="sm">
          권한 설정 안내
        </Text>
      </Group>
      <List size="sm" withPadding pr={16} spacing={8}>
        <List.Item>
          <Text size="sm">
            현재 메뉴의 상위 메뉴에 조회 권한이 없을 경우 하위 메뉴의 기능에 제한이 있습니다. (상위 메뉴 최소 조건 : 조회)
          </Text>
        </List.Item>
        <List.Item>
          <Text size="sm">조회: 메뉴 페이지 진입 권한 및 데이터 목록/상세 보기, 검색 필터 사용 권한을 포함</Text>
        </List.Item>
        <List.Item>
          <Text size="sm">등록: 신규 데이터 생성, 팝업을 통한 등록, 파일 업로드 기능을 포함</Text>
        </List.Item>
        <List.Item>
          <Text size="sm">수정: 기존 데이터의 정보 변경, 상태 수정, 설정 변경을 포함</Text>
        </List.Item>
        <List.Item>
          <Text size="sm">삭제: 데이터 영구 삭제 또는 숨김 처리, 복구 불가능한 제거 작업을 포함</Text>
        </List.Item>
      </List>
    </Paper>
  );
}
